import React from "react";
import FormattedDay from "./FormattedDay";
import WeatherIcon from "./WeatherIcon";
import "./ForecastDate.css";

export default function ForecastDate(props) {
  //from Forecast
  function maxTemperature() {
    //round temperatute
    return Math.round(props.data.temp.max);
  }
  function minTemperature() {
    //round temperature
    return Math.round(props.data.temp.min);
  }
  /* showing forecast for 1 day
   * FormattedDay - date for forecast day
   * WeatherIcon - using class for drawing icon (based on react-icons)
   * showing min and max temp using props
   */
  return (
    <div className="col-2 text-center">
      <div className="weather-forecast-date">
        <FormattedDay data={props.data.dt} />
      </div>
      <div className="weather-forecast-icon">
        <WeatherIcon info={props.data.weather[0].icon} />
      </div>

      <div className="weather-forecast-temperature">
        <span className="weather-forecast-temperature-max">
          {minTemperature()}°{" "}
        </span>
        <span className="weather-forecast-temperature-min">
          {" "}
          {maxTemperature()}°
        </span>
      </div>
    </div>
  );
}
